import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import PdpSharedDetailAttributeLink from './helpers/PdpSharedDetailAttributeLink';

// helpers
import get from 'lodash.get';

function PdpSharedDetailStone({ item }) {
    return (
        <PdpSharedDetailAttributeLink
            item={item}
            dataTn="pdp-spec-stone"
            attributes={get(item, 'attributes.stone')}
        />
    );
}

PdpSharedDetailStone.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailStone, {
    item: graphql`
        fragment PdpSharedDetailStone_item on Item {
            ...PdpSharedDetailAttributeLink_item
            attributes {
                stone: material(attributeType: stone) {
                    ...PdpSharedDetailAttributeLink_attributes
                }
            }
        }
    `,
});
